import React, { useContext, useState } from "react";
import { Redirect } from "react-router-dom";
import { ConfigurationContext } from '../context/ConfigurationContext'
import { UserContext } from '../context/UserContext'
import Container from '../components/Container'
import { v4 as uuidv4 } from 'uuid';


const StartView = () => {
  const { configurations } = useContext(ConfigurationContext);
  const { 
    type,
    setType,
    setVehicle,
    configurationId,
    setConfigurationId 
  } = useContext(UserContext);

  if(!configurations) return <Redirect to='/'/>;
  if(type && configurationId) return <Redirect to='/config'/>;

  function handleClick(e) {
    setConfigurationId(e.target.dataset.value);
    setVehicle(e.target.dataset.vehicle);
  }

  const vehicle_types     = configurations.items.find( item => item.fordonstyp === 'vehicle_types' );
  const car_meta          = configurations.items.find( item => item.fordonstyp === 'bil_meta' );
  const after_vehicle_meta  = configurations.items.find( item => item.fordonstyp === 'efterfordon_meta' );

  return (
    <Container>
      <div class="container max-w-3xl mx-auto mt-20">
        {!type ? 
          <>
            <div class="text-center">
              <h1 class="text-3xl sm:text-5xl font-bold mb-10">Välj önskad påbyggnad</h1>

              <p class="text-base sm:text-xl mb-10">{vehicle_types.text}</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-10">
              <div>
                <img className="w-full" src={car_meta.img} />

                <button className="btn sm:text-xl text-medium w-full font-medium no-underline text-black inline-block py-3 sm:px-3 sm:py-4 bg-white rounded-tl-3xl rounded-br-3xl" onClick={ e => { setType(e.target.dataset.value) } } data-value="bil">
                  Bil
                </button>
              </div>

              <div>
                <img className="w-full" src={after_vehicle_meta.img} />

                <button className="btn sm:text-xl text-medium w-full font-medium no-underline text-black inline-block py-3 sm:px-3 sm:py-4 bg-white rounded-tl-3xl rounded-br-3xl" onClick={ e => { setType(e.target.dataset.value) } } data-value="efterfordon">
                  Efterfordon
                </button>
              </div>
            </div>
          </>
        : !configurationId ?
          <>
            <div class="text-center">
              <h1 class="text-3xl sm:text-5xl font-bold mb-10">{ type === 'bil' ? car_meta.title : type === 'efterfordon' ? after_vehicle_meta.title : null }</h1>

              <p class="text-base sm:text-xl sm:text-xl mb-10">{ type === 'bil' ? car_meta.text : type === 'efterfordon' ? after_vehicle_meta.text : null  }</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-10">
              { 
              configurations.items.filter( item => item.fordonstyp === type ).map( item => (
                <button key={uuidv4()} className="btn sm:text-xl text-medium w-full font-medium no-underline text-black inline-block py-3 sm:px-3 sm:py-4 bg-white rounded-tl-3xl rounded-br-3xl" onClick={ handleClick } data-vehicle={ item.title } data-value={item.id}>
                  { item.title }
                </button>
                ) )
              }
            </div>
          </>
        : null
        }
      </div>
    </Container>
  );
};

export default StartView;
